<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div class="QZ04">
        <div class="position">
          <div style="display: flex; flex-direction: column">
            <step-progress
              :steps="mySteps"
              :current-step="currentStep"
              icon-class="fa fa-check fa-lg"
              v-if="disable == false"
            ></step-progress>
            <div class="display_quiz">
              <div
                v-if="getWidth >= 1025 && disable == false"
                class="icon_arrow"
              >
                <div class="arrow_left" @click="onPrev">
                  <img
                    style="width: 40%; height: 40%"
                    src="@/assets/images/CH2/left-arrow.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="card">
                <div class="container_CIT01">
                  <div class="block">
                    <CRow style="margin-bottom: 1%">
                      <CCol col="12" style="display: flex">
                        <div :class="checkLangClass() + 'font_setting'">
                          <p>
                            {{ checkLanguage(question) }}
                          </p>
                        </div>
                      </CCol>
                    </CRow>
                  </div>
                  <CRow>
                    <CCol>
                      <div style="padding: 2%">
                        <CRow alignHorizontal="center">
                          <div class="component_select">
                            <CCol
                              col="12"
                              style="
                                display: flex;
                                align-item: center;
                                flex-wrap: wrap;
                                justify-content: center;
                                margin-top: 1%;
                                margin-bottom: 1%;
                              "
                            >
                              <div
                                v-for="i in ans"
                                :key="i.id"
                                class="button_answer fontChinese"
                                @click="remove_ans(i.order, i.text)"
                              >
                                {{ i.text }}
                              </div>
                            </CCol>
                          </div>
                        </CRow>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <div style="padding: 2%">
                        <CRow alignHorizontal="center">
                          <div class="component_select">
                            <CCol
                              col="12"
                              style="
                                display: flex;
                                align-item: center;
                                flex-wrap: wrap;
                                justify-content: center;
                                margin-top: 1%;
                                margin-bottom: 1%;
                              "
                            >
                              <div
                                v-for="i in sort_data"
                                :key="i.order"
                                class="button_text fontChinese"
                                @click="select_ans(i.order, i.question)"
                              >
                                {{ i.question }}
                              </div>
                            </CCol>
                          </div>
                        </CRow>
                      </div>
                    </CCol>
                  </CRow>
                </div>
              </div>
              <div class="icon_arrow" v-if="getWidth >= 1025">
                <div class="arrow_right" @click="onNext">
                  <img
                    style="width: 40%; height: 40%"
                    src="@/assets/images/CH2/right-arrow.png"
                    alt=""
                  />
                </div>
              </div>
              <div v-else class="menu_btn">
                <div class="btn_prev">
                  <div class="btn_left" @click="onPrev" v-if="disable == false">
                    <div class="font_prev">
                      <b>PREVIOUS</b>
                    </div>
                  </div>
                </div>
                <div class="btn_next">
                  <div class="btn_right" @click="onNext">
                    <div class="font_next">
                      <b>NEXT</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import LoadingMDL from '@/components/loading/LoadingMDL';
import {mapGetters} from 'vuex';
import '../../../assets/scss/chinessStyle2.scss';
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';

export default {
  components: {LoadingMDL, StepProgress},
  name: 'QZ04',
  props: {},
  data() {
    return {
      ans: [],
      loading: true,
      text_ans: '',
      question: '',
      content: [],
      sort_data: [],
      language: 'en',
      navigation: [],
      answer: null,
      length_answer: 0,
      getWidth: window.innerWidth,
      dataLength: 0,
      mySteps: [],
      disable: false,
      criteria_id: '',
      currentStep: null,
      startTime: '',
      condition: [],
      topic: {},
      // code: "605418cb883ae722ba1b0c5f",
      code: '',
      section: '',
      chapter: null,
      v3Data: null,
      v3Score: 0,
    };
  },
  updated() {},
  methods: {
    onLoadData() {
      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];
      this.language = this.$store.getters['language/getLanguage'];

      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
    },
    // getTemplateAndProgress() {
    //   this.mySteps = [];
    //   //get progress logic here

    //   this.startTime = this.$helpers.getDateFormat();
    //   this.v3Data = this.$store.state.v3.templates.templates[0];
    //   const data = this.v3Data;

    //   this.navigation = data.navigate;
    //   //ans,choices
    //   this.answer = data.content.item[0].answers[0].answer;
    //   const choices = data.content.item[0].choices.filter((i) => {
    //     if (i.order != null || i.order != undefined) {
    //       return i;
    //     }
    //   });
    //   //sort
    //   this.sort_data = choices.sort((a, b) => {
    //     return a.order.localeCompare(b.order);
    //   });
    //   this.dataLength = this.sort_data.length;

    //   for (let index = 0; index < this.sort_data.length; index++) {
    //     let id = index + 1;
    //     let text = '_';
    //     this.ans.push({id, text});
    //   }
    //   this.question = data.content.item[0].title;

    //   // if (!this.disable) {
    //   //   await this.setProgress(value);
    //   // }

    //   this.loading = false;
    // },
    checkLangClass() {
      if (this.language == 'CN') {
        return 'fontChinese ';
      } else {
        return '';
      }
    },
    onPrev: function () {
      // if (this.navigation.previous.action != null) {
      //   var str = this.navigation.previous.action.split('-');
      //   let body = '/' + str[0] + '/' + str[1];
      //   if (str[0] == this.$route.name) {
      //     let payload = {
      //       templateCode: this.navigation.previous.action,
      //       // code: "605418cb883ae722ba1b0c5f",
      //       code: this.code,
      //       // section: "testing",
      //       section: this.section,
      //     };
      //     this.$store.dispatch('template/fetchTemplateAndProgress', payload);
      //     this.$router.push(body);
      //     this.loading = true;
      //   } else {
      //     this.$router.push(body);
      //   }
      // }

      const str = this.navigation.previous.action.split('-');
      const path = `/v3/${str[0]}/${str[1]}`;
      this.$router.push(path);
    },
    onNext: function () {
      if (this.navigation.next.action != null) {
        let checker = true;
        for (let index = 0; index < this.ans.length; index++) {
          if (this.ans[index].text == '_') {
            checker = false;
          }
        }
        if (this.ans != null && checker) {
          this.text_ans = this.ans
            .map((i) => {
              return i.text;
            })
            .toString()
            .replace(/,/g, '')
            .toLowerCase();
          //compare answer before get score
          if (this.text_ans === this.answer) {
            this.v3Score = 1;
          } else {
            this.v3Score = 0;
          }
          this.commitUserProgress();
        } else {
          alert('Please select all answers.');
        }
      }
    },
    commitUserProgress: function () {
      this.loading = true;
      // let userCriteria = {
      //   code: this.code,
      //   contentId: this.criteria_id,
      //   codeTemplate: this.$route.name + '-' + this.$route.params.id,
      // answering: [
      //   {
      //     answer: this.text_ans,
      //   },
      // ],
      //   topic: this.topic,
      //   chapter: this.chapter,
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // };
      // this.$store.dispatch('template/commitUserProgressChinese2', userCriteria);

      //check answer

      // // ส่วนนี้เป็นส่วนของการบันทึกข้อมูลไปยัง DB โดยส่งข้อมูลไปยัง backend ในรูปแบบนี้โดยไม่ต้องรอค่ารีเทิร์น
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [
            {
              answer: this.text_ans,
            },
          ],
          progress: 100,
          score: this.v3Score, // ดูก่อนว่าเก็บคะแนนป่าว
          maxScore: 1,
        },
      ];
      console.log(data, this.v3Score, this.v3Data.codeItem, 'log payload');

      // this.$store.commit('v3/keepScore', {score: this.v3Score, maxScore: 1});
      this.$store.dispatch('v3/saveContent', data);
      // //===========================================================

      const str = this.navigation.next.action.split('-');

      const path = `/v3/${str[0]}/${str[1]}`;
      this.$router.push(path);
    },
    select_ans: function (id, text) {
      let dataTmp = this.sort_data;
      for (let index = 0; index < this.ans.length; index++) {
        if (this.ans[index].text == '_') {
          this.ans[index].text = text;
          this.ans[index].order = id;
          break;
        }
      }
      for (let index = 0; index < dataTmp.length; index++) {
        if (dataTmp[index].question == text) {
          dataTmp.splice(index, 1);
          break;
        }
      }
    },
    remove_ans: function (id, text) {
      let dataTmp = this.ans;
      if (text != '_') {
        this.sort_data.push({
          order: id,
          question: text,
        });
        for (let index = 0; index < dataTmp.length; index++) {
          if (dataTmp[index].text == text) {
            dataTmp[index].text = '_';
            break;
          }
        }
      }
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.language) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log('change language is error 1!!');
        }
      } else {
        console.log('change language is error 2!!');
      }
    },
    setProgress: function (value) {
      return new Promise((resolve, reject) => {
        value.chapter.item.map((i) => {
          switch (i.content.type) {
            case 'topic':
              this.mySteps.push('Topic');
              break;
            case 'flipcard':
              this.mySteps.push('Vocabulary');
              break;
            case 'assignment':
              this.mySteps.push('Assignment');
              break;
            case 'test':
              this.mySteps.push('Test');
              break;
            default:
              this.mySteps.push(i.content.type);
              break;
          }
        });
        // value.checkPoints.map((i) => {
        //   if (i._id.topic == value.topicPosition.codeItem) {

        //   }
        // });
        this.currentStep = value.topicPosition.index - 1;
        resolve();
      });
    },
    resetLocalState() {
      this.ans = [];
      this.text_ans = '';
      this.question = '';
      this.sort_data = [];
      this.answer = null;
      this.length_answer = 0;
      this.mySteps = [];
      this.currentStep = null;
      this.v3Score = 0;
    },
  },
  computed: {
    ...mapGetters({
      // getTemplateAndProgress: 'template/getTemplateAndProgress',
      getResponseStatus: 'template/getResponseStatus',
      getTestTemplate: 'template/getTestTemplate',
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;
      this.mySteps = [];
      this.startTime = this.$helpers.getDateFormat();

      this.v3Data = val;
      const template = val.templates[0];

      this.navigation = template.navigate;

      //ans,choices
      this.answer = template.content.item[0].answers[0].answer;
      const choices = template.content.item[0].choices.filter((i) => {
        if (i.order != null || i.order != undefined) {
          return i;
        }
      });
      //sort
      this.sort_data = choices.sort((a, b) => {
        return a.order.localeCompare(b.order);
      });
      this.dataLength = this.sort_data.length;

      for (let index = 0; index < this.sort_data.length; index++) {
        let id = index + 1;
        let text = '_';
        this.ans.push({id, text});
      }
      this.question = template.content.item[0].title;

      this.loading = false;
    },
    '$route.params.id'() {
      //use to watch param id if changes
      //clear old state and Load new data
      this.loading = true;

      this.resetLocalState();
      this.onLoadData();
    },
    // getTemplateAndProgress: async function (value) {
    //   this.mySteps = [];
    //   let templateType = ['pretest', 'posttest'];
    //   this.disable = templateType.includes(value.topicPosition.type);

    //   this.startTime = this.$helpers.getDateFormat();
    //   if (value.criteria.condition.criteriaType.length != 0) {
    //     this.condition.push({
    //       criteria: value.criteria.condition.criteriaType[0]._id,
    //       val: value.criteria.condition.criteriaType[0].val,
    //     });
    //   }
    //   this.criteria_id = value.criteria._id;
    //   this.chapter = value.chapter;
    //   this.topic = value.topicPosition;

    //   this.navigation = value.templateData.navigate;
    //   this.answer = value.templateData.content.item[0].answers[0].answer;
    //   const choices = await value.templateData.content.item[0].choices.filter(
    //     (i) => {
    //       if (i.order != null || i.order != undefined) {
    //         return i;
    //       }
    //     }
    //   );
    //   this.sort_data = choices.sort((a, b) => {
    //     return a.order.localeCompare(b.order);
    //   });
    //   this.dataLength = this.sort_data.length;

    //   for (let index = 0; index < this.sort_data.length; index++) {
    //     let id = index + 1;
    //     let text = '_';
    //     this.ans.push({id, text});
    //   }
    //   this.question = value.templateData.content.item[0].title;

    //   if (!this.disable) {
    //     await this.setProgress(value);
    //   }

    //   this.loading = false;
    // },
    // getResponseStatus: function (val) {
    //   if (val.status == 200) {
    //     let str = this.navigation.next.action.split('-');
    //     let body = '/' + str[0] + '/' + str[1];
    //     if (this.$route.name == str[0]) {
    //       this.ans = [];
    //       this.text_ans = '';
    //       this.question = '';
    //       this.sort_data = [];
    //       this.answer = null;
    //       this.length_answer = 0;
    //       this.mySteps = [];
    //       this.currentStep = null;

    //       let payload = {
    //         templateCode: this.navigation.next.action,
    //         code: this.code,
    //         // section: "testing",
    //         section: this.section,
    //       };
    //       this.$store.dispatch('template/fetchTemplateAndProgress', payload);
    //       if (this.disable) {
    //         this.$router.replace(body);
    //       }
    //       this.$router.push(body);
    //     } else {
    //       this.$router.push(body);
    //     }
    //   }
    // },
    storeLanguage: function (value) {
      this.language = value;
    },
  },
  created() {},
  mounted() {
    // let payload = {
    //   templateCode: this.currentRoute,
    //   code: this.code,
    //   // section: "testing",
    //   section: this.section,
    // };
    // this.$store.dispatch('template/fetchTemplateAndProgress', payload);
    this.onLoadData();
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
::v-deep .step-progress__wrapper {
  width: 75%;
}

::v-deep .step-progress__wrapper-before {
  top: 45%;
  height: 10px;
  opacity: 0.5;
  background-color: #3b3b38 !important;
}

::v-deep .step-progress__step--valid:after {
  background-color: #1d5bd7;
}

::v-deep .step-progress__step--valid:after {
  border: #1d5bd7 solid !important;
}

::v-deep .step-progress__step--active:after {
  border: #1d5bd7 solid !important;
}

::v-deep .step-progress__step--active .step-progress__step-label,
.step-progress__step--active span {
  color: #1d5bd7;
}

::v-deep .step-progress__wrapper-after {
  top: 45%;
  height: 10px;
  background-color: #1d5bd7 !important;
  opacity: 0.5;
}

::v-deep .step-progress__step span {
  font-size: 0px;
}

::v-deep svg:not(:root).svg-inline--fa {
  width: 20px;
  height: 20px;
}

::v-deep .step-progress__step-label {
  top: -50px;
}

::v-deep .step-progress__step--valid .step-progress__step-label {
  color: #1d5bd7;
}

::v-deep .step-progress__step:after {
  width: 40px;
  height: 40px;
  border: #808080 solid;
}

::v-deep .step-progress__bar {
  margin-bottom: 10px;
  height: 6s0px;
}

.font_prev {
  color: #1d5bd7;
  font-size: 16px;
}

.font_next {
  color: white;
  font-size: 16px;
}

.btn_prev {
  margin-right: 5%;
  margin-left: 5%;
  margin-top: 5%;
}

.btn_next {
  margin-right: 5%;
  margin-left: 5%;
  margin-top: 5%;
}

.display_quiz {
  display: flex;
  flex-direction: row;
}

.btn_left {
  width: 100px;
  height: 50px;
  border-radius: 10px;
  background-color: #e6efff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn_right {
  width: 100px;
  height: 50px;
  border-radius: 10px;
  background-color: #1d5bd7;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.QZ04 {
  background-color: #ffccd5;
  padding-bottom: 5%;
  padding-top: 5%;
}

.position {
  display: flex;
  align-content: center;
  justify-content: center;
  padding-top: 5%;
  padding-bottom: 7%;
}

.icon_arrow {
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 2%;
  margin-right: 2%;
}

.arrow_left,
.arrow_right {
  width: 60px;
  height: 60px;
  background-color: #e6efff;
  cursor: pointer;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.test_flex_start {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.card {
  background-color: white;
  width: 1000px;
  height: auto;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px;
  /* 5px rounded corners */
  padding-top: 20px;
  padding-bottom: 20px;
}

.block {
  background-color: #e6efff;
  width: 100%;
  height: auto;
  border-radius: 7px;
  margin-bottom: 1%;
}

.font_setting {
  padding: 20px 20px 20px 20px;
  color: black;
  font-size: 22px;
}

.button_setting {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 2%;
  justify-content: center;
  align-items: center;
  background-color: #e6efff;
  color: #1d5bd7;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
}

.btn-exit {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  position: absolute;
  padding-top: 0px;
  padding-bottom: 0px;
  border-radius: 8px !important;
  border-color: #ed8e91;
  background-color: #ed8e91;
  left: 98%;
  color: white;
  z-index: 90;
}

.container_CIT01 {
  padding-left: 4%;
  padding-right: 4%;
  padding-top: 1%;
}

.ContentProgressBar {
  // padding-left: 40%;
  display: flex;
  justify-content: center;

  .ProgressBar {
    background-color: #e6efff !important;
    margin-top: 3%;
    margin-bottom: 3%;
    width: 100%;
    height: 10px;
    border-radius: 10px !important;
  }

  // .progress-bar {
  //     background-color: #b3b3b3 !important;
  // }
}

.progress-bar-striped {
  background-image: none !important;
}

/* Add rounded corners to the top left and the top right corner of the image */
img {
  border-radius: 5px 5px 0 0;
}

.button_text {
  background-color: #1d5bd7;
  /* Green */
  border: none;
  color: white;
  padding: 5px 20px 5px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 24px;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 10px;
  margin-right: 2%;
}

.button_answer {
  background-color: #ed8e91;
  /* Green */
  border: none;
  color: white;
  padding: 5px 20px 5px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 24px;
  cursor: pointer;
  border-radius: 5px;
  margin-right: 2%;
  margin-top: 10px;
}

.component_select {
  width: 100% !important;
  height: 100%;
  display: flex;
  padding: 2%;
  justify-content: center;
  align-items: center;
  border: 2px solid #e6efff;
  color: #1d5bd7;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
  margin-top: -1%;
}

// resolution mobile
@media screen and (min-width: 300px) and (max-width: 415px) {
  .QZ04 {
    background-color: #ffccd5;
    padding-top: 20%;
    padding-bottom: 10%;
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .display_quiz {
    flex-direction: column;
  }

  .position {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
  }

  .font_prev {
    font-size: 16px;
  }

  .font_next {
    font-size: 16px;
  }

  .arrow_left {
    width: 100px;
    height: 50px;
    border-radius: 10px;
  }

  .arrow_right {
    width: 100px;
    height: 50px;
    border-radius: 10px;
  }

  .block {
    margin-bottom: 10px;
    height: auto;
  }

  .card {
    width: 350px;
    height: auto;
    padding: 2%;
    margin: auto 0;
  }

  .button_setting {
    width: 150px;
    height: 35px;
  }

  .component_select {
    width: 95% !important;
  }

  .font_setting {
    font-size: 14px;
    padding: 20px 20px 0px 20px;
  }

  .arrow_left {
    margin-left: 5px;
  }

  .button_text {
    padding: 2px 5px 2px 5px;
    font-size: 18px;
    margin-right: 0;
    margin-left: 3%;
    margin-top: 10px;
  }

  .button_answer {
    padding: 2px 5px 2px 5px;
    font-size: 18px;
    margin-right: 0;
    margin-left: 3%;
    margin-top: 10px;
  }

  .arrow_right {
    margin-right: 5px;
  }
}

@media screen and (min-width: 768px) and (max-width: 769px) {
  .QZ04 {
    background-color: #ffccd5;
    padding-bottom: 15%;
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .display_quiz {
    flex-direction: column;
  }

  .position {
    padding-top: 10%;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
  }

  .btn_left {
    width: 150px;
    height: 50px;
  }

  .btn_right {
    width: 150px;
    height: 50px;
  }

  .card {
    width: 700px;
    height: auto;
  }
}

@media only screen and (min-width: 1023px) and (max-width: 1024px) {
  .QZ04 {
    background-color: #ffccd5;
    padding-bottom: 5%;
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .position {
    padding-top: 10%;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
  }

  .display_quiz {
    flex-direction: column;
  }

  .card {
    width: 800px;
    height: auto;
  }

  .btn_left {
    width: 150px;
    height: 50px;
  }

  .btn_right {
    width: 150px;
    height: 50px;
  }
}
</style>
